import React, { useRef } from 'react'
import { GameCssStyles } from '../GameCssStyles'
import {
    Box,
    TextField,
    Typography,
    Grid,
    IconButton,
    FormControlLabel,
    Checkbox,
    Button,
    Input,
    MenuItem,
    Select,
    Radio,
    RadioGroup,
    FormControl,
    InputLabel
} from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import { GAME_TYPE, RATIO_OPTIONS } from '../GameConstant';
import { checkAspectRatio, getMediaDimensions, getMediaDimensionsAndRatio, getMediaTypeFromUrl, getValueByPath } from '../../../utility/Common';
import { getSingleFileByNameFromAWSS3Bucket, uploadFileToAWSS3Bucket } from '../../../services/uploadFileOnAWS_S3_Bucket';

const defaultQuestion = {
    questionText: "",
    status: "",
    multimedia: {
        mediaType: "",
        url: "",
        aspectRatio: ""
    },
    options: [
        {
            _id: "",
            text: "",
            label: "1",
            multimedia: {
                mediaType: "",
                url: "",
                aspectRatio: ""
            },
        }
    ],
    answer: {
        id: ""
    }
};


const QuestionEditor = ({ formGameData, handleChange }) => {

    const questionFileInputRef = useRef(null);
    const answerFileInputRefs = useRef([]);
    const question = formGameData?.question ?? null;
    const options = question?.options ?? [];

    const handleFileUpload = async (e, pathPrefix) => {
        const file = e.target.files[0];
        //console.log("file : ", file);

        const value = getValueByPath(formGameData, pathPrefix);
        const aspectRatio = value?.multimedia?.aspectRatio;
        const { width, height, mediaType, ratio } = await getMediaDimensionsAndRatio(file);

        if (file) {
            const url = URL.createObjectURL(file);
            //console.log("url : ", url);
            let mediaType = '';
            if (file.type.startsWith('image/')) mediaType = 'image';
            else if (file.type.startsWith('video/')) mediaType = 'video';
            else if (file.type.startsWith('audio/')) mediaType = 'audio';

            if (mediaType === 'image' || mediaType === 'video') {
                if (!aspectRatio) {
                    alert(`First select the aspect ratio.`);
                    return;
                }
                else {
                    const isValidRatio = await checkAspectRatio(url, aspectRatio, mediaType);
                    if (!isValidRatio) {
                        alert(`Uploaded ${mediaType} does not match selected ratio: ${aspectRatio}\nUploaded media Width: ${width} & Height: ${height} & Ratio: ${ratio}`);
                        console.log(`Uploaded ${mediaType} does not match selected ratio: ${aspectRatio}\nUploaded media Width: ${width} & Height: ${height} & Ratio: ${ratio}`);
                        return;
                    }
                }
            }

            if (pathPrefix === 'question') {
                console.log("pathPrefix : question",)
                const result = await uploadFileToAWSS3Bucket("questions", file);
                console.log("Upload AWS result : ", result)
                const fileResult = await getSingleFileByNameFromAWSS3Bucket("questions", result?.key?.split('/').pop());
                console.log("Single File AWS fileResult : ", fileResult?.url?.href)
                handleChange(`${pathPrefix}.multimedia.url`, fileResult?.url?.href);
            }
            else {
                console.log("pathPrefix : options",)
                const result = await uploadFileToAWSS3Bucket("options", file);
                console.log("Upload AWS result : ", result)
                const fileResult = await getSingleFileByNameFromAWSS3Bucket("options", result?.key?.split('/').pop());
                console.log("Single File AWS fileResult : ", fileResult?.url?.href)
                handleChange(`${pathPrefix}.multimedia.url`, fileResult?.url?.href);
            }

            console.log("pathPrefix : ", pathPrefix)
            console.log(`${pathPrefix}.multimedia.url`, url)
            handleChange(`${pathPrefix}.multimedia.mediaType`, mediaType);
        }
    };

    const createQuestion = () => {
        console.log("Creating new question", JSON.parse(JSON.stringify(defaultQuestion)));
        handleChange('question', JSON.parse(JSON.stringify(defaultQuestion)));
    }

    const addAnswer = () => {
        const newOption = {
            id: "",
            text: "",
            label: ""+(question.options.length ? (question.options.length+1) : 1),
            multimedia: {
                mediaType: "",
                url: "",
                aspectRatio: question?.multimedia?.aspectRatio ? question?.multimedia?.aspectRatio : ""
            }
        };
        handleChange('question.options', [...options, newOption]);
    };

    const removeAnswer = (index) => {
        const updated = [...options];
        updated.splice(index, 1);
        handleChange('question.options', updated);
    };

    const setCorrectAnswer = (index) => {
        handleChange('question.answer.id', index.toString());
    };

    return (
        <Box sx={GameCssStyles.containerStyleColumn_sx}>
            <Typography variant="h6" fontWeight={600} mb={0} alignSelf={"start"} justifySelf={'start'}>Game Contest Question & Answers</Typography>

            {!question ?
                (
                    <Button variant="contained" onClick={createQuestion}>
                        + Create Question
                    </Button>
                )
                :
                (
                    <Box sx={{ ...GameCssStyles.containerStyleColumnWithoutBorder_sx, width: '100%' }}>

                        {/* <Box sx={{ ...GameCssStyles.containerStyleColumn_sx, width: '100%', mt: 0 }}> */}
                            {/* Question Text and Multimedia */}
                            <TextField
                                fullWidth
                                label="Question Text"
                                multiline
                                rows={3}
                                value={question?.questionText || ''}
                                onChange={(e) => handleChange('question.questionText', e.target.value)}
                                sx={GameCssStyles.formMultiLineTextField_sx}
                            />

                            <Box sx={{ ...GameCssStyles.containerStyleRowWithoutBorder_sx, width: '100%', alignContent: "start", justifyContent: 'start' }}>
                                <Box mt={2}>
                                    {(formGameData?.type !== GAME_TYPE.PREDICT_BASED) && <Box sx={GameCssStyles.containerStyleRowWithoutBorder_sx}>
                                        <TextField
                                            fullWidth
                                            label="Question Multimedia URL"
                                            value={question?.multimedia?.url || ''}
                                            onChange={(e) => {
                                                const mediaType = getMediaTypeFromUrl(e.target.value);
                                                handleChange('question.multimedia.mediaType', mediaType);
                                                handleChange('question.multimedia.url', e.target.value)
                                            }}
                                            sx={GameCssStyles.formSingleLineTextField_sx}
                                        />

                                        <Button variant="contained" onClick={() => questionFileInputRef.current.click()}>Upload</Button>
                                        <input
                                            type="file"
                                            hidden
                                            ref={questionFileInputRef}
                                            onChange={(e) => handleFileUpload(e, 'question')}
                                            accept="image/*,video/*,audio/*"
                                        />
                                    </Box>}

                                </Box>
                                {/* Preview */}
                                {(formGameData?.type !== GAME_TYPE.PREDICT_BASED && question?.multimedia?.url) && (
                                    <Box mt={1}>
                                        {question.multimedia.mediaType === "image" ? (
                                            <img src={question.multimedia.url} alt="preview" width="200px" />
                                        ) : question.multimedia.mediaType === "video" ? (
                                            <video src={question.multimedia.url} controls width="200px" />
                                        ) : question.multimedia.mediaType === "audio" ? (
                                            <audio src={question.multimedia.url} controls />
                                        ) : null}
                                    </Box>
                                )}
                            </Box>
                        {/* </Box> */}

                        {/* Answer Options */}
                        <Box sx={{ ...GameCssStyles.containerStyleColumnWithoutBorder_sx, width: '100%', mt: 0, justifyContent: 'start', alignItems: 'start' }}>
                            <Typography fontWeight={600} mb={0}>Answers</Typography>

                            <RadioGroup
                                row
                                value={question?.multimedia?.aspectRatio || "None"}
                                //value={question?.options?.[0]?.multimedia?.aspectRatio || "None"}
                                onChange={(e) => {
                                    console.log("ratio : ", e.target.value)
                                    handleChange('question.multimedia.aspectRatio', e.target.value)
                                    options?.forEach((_, idx) => {
                                        handleChange(`question.options.${idx}.multimedia.aspectRatio`, e.target.value);
                                    });
                                }}
                                sx={{mb:1}}
                            >
                                {RATIO_OPTIONS.map((ratio) => (
                                    <FormControlLabel
                                        key={ratio?.value}
                                        value={ratio?.value}
                                        control={
                                            <Radio
                                                sx={GameCssStyles.radioButtonStyle_sx}
                                            />
                                        }
                                        label={ratio?.label}
                                    />
                                ))}
                            </RadioGroup>

                            {options?.map((option, idx) => (
                                <Box sx={{ ...GameCssStyles.containerStyleRow_sx, width: '100%' }} key={idx}>

                                    <Box sx={{ ...GameCssStyles.containerStyleColumnWithoutBorderNoColor_sx, width: '100%' }}>

                                        <TextField
                                            label="Answer Text"
                                            value={option?.text || ''}
                                            onChange={(e) => handleChange(`question.options.${idx}.text`, e.target.value)}
                                            fullWidth
                                            multiline
                                            rows={3}
                                            sx={GameCssStyles.formMultiLineTextField_sx}
                                        />

                                        <Box sx={{ ...GameCssStyles.containerStyleColumnWithoutBorderNoColor_sx, width: '100%' }}>

                                            <Box sx={{ ...GameCssStyles.containerStyleRowWithoutBorderNoColor_sx, width: '100%' }}>

                                                <TextField
                                                    label="Label"
                                                    value={option?.label || ''}
                                                    onChange={(e) => handleChange(`question.options.${idx}.label`, e.target.value )}
                                                    width="100px"
                                                    sx={GameCssStyles.formSingleLineTextField_sx}
                                                />

                                                <TextField
                                                    label="Multimedia URL"
                                                    value={option?.multimedia?.url || ''}
                                                    onChange={(e) => {
                                                        const mediaType = getMediaTypeFromUrl(e.target.value);
                                                        handleChange(`question.options.${idx}.multimedia.mediaType`, mediaType);
                                                        handleChange(`question.options.${idx}.multimedia.url`, e.target.value)
                                                    }}
                                                    fullWidth
                                                    sx={GameCssStyles.formSingleLineTextField_sx}
                                                />

                                                <Button variant="contained" onClick={() => answerFileInputRefs.current[idx].click()}>Upload</Button>
                                                <input
                                                    type="file"
                                                    hidden
                                                    ref={(el) => (answerFileInputRefs.current[idx] = el)}
                                                    onChange={(e) => handleFileUpload(e, `question.options.${idx}`)}
                                                    accept="image/*,video/*,audio/*"
                                                />
                                            </Box>

                                            <Box sx={{ ...GameCssStyles.containerStyleRowWithoutBorderNoColor_sx, width: '100%', gap: 10, justifyContent: 'end', alignItems: 'center' }}>

                                                {/* <FormControlLabel
                                                    control={
                                                        <Radio
                                                            checked={question?.answer?.id === idx.toString()}
                                                            onChange={() => setCorrectAnswer(idx)}
                                                        />
                                                    }
                                                    label="Correct"
                                                /> */}

                                                <Button variant="contained" sx={{ backgroundColor: 'red', color: 'white' }} onClick={() => removeAnswer(idx)}>Remove</Button>

                                            </Box>

                                        </Box>

                                    </Box>

                                    {/* Preview */}
                                    {option?.multimedia?.url && (
                                        <Box mt={1}>
                                            {option.multimedia.mediaType === "image" ? (
                                                <img src={option.multimedia.url} alt="preview" width="200px" />
                                            ) : option.multimedia.mediaType === "video" ? (
                                                <video src={option.multimedia.url} controls width="200px" />
                                            ) : option.multimedia.mediaType === "audio" ? (
                                                <audio src={option.multimedia.url} controls />
                                            ) : null}
                                        </Box>
                                    )}

                                </Box>
                            ))}

                            <Box mt={2}>
                                <Button startIcon={<Add />} variant="contained" onClick={addAnswer}>
                                    Add Answer
                                </Button>
                            </Box>
                        </Box>

                        {(options && formGameData?._id) && <Box sx={{ ...GameCssStyles.containerStyleColumnWithoutBorder_sx, width: '100%', mt: 3, justifyContent: 'start', alignItems: 'start' }}>
                            <Typography fontWeight={600} mb={0}>Correct Answers</Typography>

                            <Box sx={{ ...GameCssStyles.containerStyleRowWithoutBorderNoColor_sx, width: '100%', gap: 10, justifyContent: 'end', alignItems: 'center' }}>

                                <FormControl fullWidth margin="normal">
                                    <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>Correct Answer</InputLabel>
                                    <Select
                                        value={options?.some(show => show?._id === question?.answer?.id) ? question?.answer?.id : ''}
                                        onChange={(e) => {
                                            //console.log("answer release : ",e.target.value)
                                            handleChange('question.answer.id', e.target.value)
                                        }}
                                        label="Correct Answer"
                                        sx={GameCssStyles.formFiledStyle_sx2}
                                    >
                                        <MenuItem value="" disabled>
                                            Select Correct Answer
                                        </MenuItem>
                                        {options?.map((item, idx) => {
                                            return (<MenuItem key={idx} value={item?._id} sx={GameCssStyles.menuItemStyle_sx}> {item?.text} </MenuItem>)
                                        })}
                                    </Select>
                                </FormControl>

                                <Button variant="contained" sx={{ backgroundColor: 'red', color: 'white' }} onClick={() => handleChange('releaseAnswer')}>Release Answer</Button>

                            </Box>
                        </Box>}
                    </Box>
                )}
        </Box>
    )
}

export default QuestionEditor
